import React, { Component } from "react";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
import {mapType} from '../../../../utils/constants';
import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import Actions from '../Actions/Actions';
import ReviewAlert from './ReviewAlert/ReviewAlert';
import ReviewMatchColumns from './ReviewMatchColumns/ReviewMatchColumns';
import ReviewOfficeHierarchy from './ReviewOfficeHierarchy/ReviewOfficeHierarchy';
import ReviewMapGenderTypes from './ReviewMapGenderTypes/ReviewMapGenderTypes';
import ReviewMapPositions from './ReviewMapPositions/ReviewMapPositions';
import ReviewMapPerformanceGrades from './ReviewMapPerformanceGrades/ReviewMapPerformanceGrades';
import ReviewMapEthnicity from './ReviewMapEthnicity/ReviewMapEthnicity';
import OfficeChange from '../../OrgChart/OfficeNameChange'
import * as actionCreators from '../../../../modules/actions/index';

import { connect } from 'react-redux';

import ReviewMapVeteran from './ReviewMapVeteran/ReviewMapVeteran'
import ReviewMapReligion from './ReviewMapReligion/ReviewMapReligion'
import ReviewMapSexualOrientation from './ReviewMapSexualOrientation/ReviewMapSexualOrientation'
import ReviewMapDisability from './ReviewMapDisability/ReviewMapDisability'


import ReviewUploadDataMappedColumns from './ReviewUploadDataMappedColumns/ReviewUploadDataMappedColumns';
import ReviewMapSeparation from './ReviewMapSeparation/ReviewMapSeparation';
import moment from 'moment';
import '../../OrganizationSetup.css';
import './Review.css';

class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChangeOffice:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showOffices = () => {
    console.log("change office name")
    // this.setState((prev) => ({changeOffice : true }));
    this.setState({isChangeOffice:true})
  }

  goToOfficeManagement =()=>{
    let {newOfficesFound,problemOffices}=this.props
    console.log(newOfficesFound,problemOffices)
    let result = []
    this.props.manageNewOffices(newOfficesFound)
    this.props.history.push(`/home/enterprise-info/org-chart`)
  }
  
 render() {
    // console.log('Review Props', this.props);
    let {top, instruction, matchedColumns, file,
      newOffices, type, selectedDate, error, newOfficesFound, errorMessage,isRepeatFlow} = this.props;
      // console.log(newOffices)
      let {isChangeOffice}=this.state
   return <div className={top}>
   {
     error ? 
      <div>
       
     <ErrorMessage message={errorMessage}/> 
     {newOffices && newOffices.length>0?
     <div className="mb50">
      <div>
        Number of new offices: {newOffices.length}   
      </div> 
      {/* {newOffices.map(e=>{
       return <div> {e.newOfficePath} </div>
      })} */}
              {/* <div className="w100 ooColor btn">
											<span className="whiteTxt txt-sign-in-btn">
												Create new office?
											</span>
								</div>

                    <p className={`loginButtonContent`}>
										Or
									</p> */}

        {/* <Link to={'/enterprise-info/org-chart'} className="w100 ooColor btn">
											<span className="whiteTxt txt-sign-in-btn">
                        Change existing office name?
											</span>
                    </Link> */}

                <div 
                  onClick={this.goToOfficeManagement}
                 className="ooColor btn inlineBlock mt20" 
                // onClick={this.showOffices}
                >
											<span className="whiteTxt txt-sign-in-btn">
                        {/* Change existing office name? */}
                        Modify Org chart
											</span>
                     
										</div>

                      {isChangeOffice?
                        <OfficeChange newOffices={newOffices} newOfficesFound={newOfficesFound} /** hierarchy={} */ />
                      :
                      null
                      }
        
        </div>
        :
        null
      }
     </div>
     : 
     null
   }

   {isChangeOffice===false?
    <span>
  
       <Row>
         <Col className="review-instruction">{instruction? instruction:"Please review the selections you made before you finalise the mapping."}</Col>
       </Row>
       <Row className="mt20">
         <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
         {type === mapType.uploadEmployeeDataCsv &&
           <div className="review-sub-section">
             <span className="review-file-txt">Date: </span>
             <span className="review-file-name">
               {selectedDate ? moment(selectedDate).format('MM/DD/YYYY') : ""}
             </span>
           </div>}
           <div className="review-sub-section">
             <span className="review-file-txt">File: </span>
             <span className="review-file-name">
               {file && file.name ? file.name : file? file:""}
             </span>
           </div>
           {this.props.fileType?
            <div className="review-sub-section">
             <span className="review-file-txt">File Type: </span>
             <span className="review-file-name">
               {this.props.fileType? this.props.fileType : ""}
             </span>
           </div>
           :
           null
           }
         {(type === mapType.orgChart || type === mapType.separation 
          || type === mapType.gender || type === mapType.positions 
          || type === mapType.performance) && <div className="review-sub-section">
           <ReviewMatchColumns {...this.props} />
         </div>}
           {type === mapType.orgChart && <ReviewOfficeHierarchy {...this.props} />}
           {type === mapType.gender && <ReviewMapGenderTypes {...this.props} />}
           {type === mapType.positions && <ReviewMapPositions {...this.props} />}
           {type === mapType.performance && <ReviewMapPerformanceGrades {...this.props} />}
           {type === mapType.ethnicity && <ReviewMapEthnicity {...this.props} />}



           {type === mapType.veteran && <ReviewMapVeteran {...this.props} />}
           {type === mapType.sexualOrientation && <ReviewMapSexualOrientation {...this.props} />}
           {type === mapType.disability && <ReviewMapDisability {...this.props} />}
           {type === mapType.religion && <ReviewMapReligion {...this.props} />}




           {type === mapType.separation && <ReviewMapSeparation {...this.props} />}
           {type === mapType.uploadEmployeeDataCsv && <ReviewUploadDataMappedColumns {...this.props} />}
         </Col>
       </Row>

       <ReviewAlert {...this.props} message="Please note this data, will be used for KPI calculations for your office and for all the offices reporting to your office." />
       <Actions
        nxtBtnIcon={ type === mapType.orgChart || isRepeatFlow ? "flaticon-tick" : "flaticon-next" } 
        {...this.props} />
       </span>
        :
    
        null
        }
     </div>;

  }
}


const mapDispatchToProps = dispatch => {
	return {
    manageNewOffices: (newOfficesFound) => dispatch(actionCreators.manageNewOffices(newOfficesFound)),
	}
}

export default connect(null,mapDispatchToProps)(Review);